
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={handleLogoClick}>
            <img 
              src="https://static.readdy.ai/image/95ea3a6b9baab5551419459f4fb45aca/6ba3f8ee12e3b70a75ca03e1f2f1f75b.png"
              alt="Stoodio Logo"
              className="h-10 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#models" className="text-gray-700 hover:text-[#0069a5] font-medium transition-colors cursor-pointer">
              Models
            </a>
            <a href="#process" className="text-gray-700 hover:text-[#0069a5] font-medium transition-colors cursor-pointer">
              Process
            </a>
            <a href="#about" className="text-gray-700 hover:text-[#0069a5] font-medium transition-colors cursor-pointer">
              About
            </a>
            <a href="#contact" className="text-gray-700 hover:text-[#0069a5] font-medium transition-colors cursor-pointer">
              Contact
            </a>
            <button className="bg-[#0069a5] hover:bg-[#005a8f] text-white px-6 py-2 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer">
              Get Started
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-[#0069a5] focus:outline-none cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col space-y-4">
              <a href="#models" className="text-gray-700 hover:text-[#0069a5] font-medium transition-colors cursor-pointer">
                Models
              </a>
              <a href="#process" className="text-gray-700 hover:text-[#0069a5] font-medium transition-colors cursor-pointer">
                Process
              </a>
              <a href="#about" className="text-gray-700 hover:text-[#0069a5] font-medium transition-colors cursor-pointer">
                About
              </a>
              <a href="#contact" className="text-gray-700 hover:text-[#0069a5] font-medium transition-colors cursor-pointer">
                Contact
              </a>
              <button className="bg-[#0069a5] hover:bg-[#005a8f] text-white px-6 py-2 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer w-fit">
                Get Started
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
